import React, {Component} from "react"

import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {RouterLink} from "@irati/ui/src/Link"
import {H2, Body, Label} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import {FormattedMessage} from "@irati/utils/lang"
import theme from "@irati/ui/src/global/theme"
import Form from "@irati/ui/src/Form"
import {Input} from "@irati/ui/src/FormItem"
import Flex from "@irati/ui/src/Flex"
import Spacing from "@irati/ui/src/Spacing"
import Validation from "@irati/utils/validation"
import businessService from "@irati/identity/services/business"
import authentication from "@irati/auth"
import {UpdateBusinessInput} from "@irati/types/ops"

import {SETTINGS_LOGIN_INTEGRATION_SSO} from "../../../../../routes/routeConfig"
import {CustomSSOImage} from "../../../../../images/index"

interface Props {}

interface State {
  customText: string
  isUpdated: boolean
  loadCustomSSO: Promise<void> | null
  loadDefaultSSO: Promise<void> | null
}

class CustomSSOName extends Component<Props, State> {
  state: State = {
    customText: "",
    isUpdated: false,
    loadCustomSSO: null,
    loadDefaultSSO: null
  }

  updateSSOButtonText = () => {
    const updateBusinessInput: UpdateBusinessInput = {
      uuid: authentication.business().uuid,
      loginPageSsoButtonText: this.state.customText
    }
    const loadCustomSSO = businessService.update({data: updateBusinessInput}).then(this.handleSaved)
    this.setState({loadCustomSSO})
  }

  useDefaulSSOButtonText = () => {
    const updateBusinessInput: UpdateBusinessInput = {
      uuid: authentication.business().uuid,
      loginPageSsoButtonText: ""
    }
    const loadDefaultSSO = businessService.update({data: updateBusinessInput}).then(() => this.setState({customText: ""}))
    this.setState({loadDefaultSSO})
  }

  handleInputChange = (value: string) => {
    this.setState({customText: value})
  }

  handleSaved = () => {
    this.setState({isUpdated: true})
    setTimeout(() => {
      this.setState({isUpdated: false})
    }, 5000)
  }

  render() {
    const {customText, isUpdated, loadCustomSSO, loadDefaultSSO} = this.state

    return (
      <>
        <Icon icon={IconTypes.chevronLeft} color={theme.colors.primary2} marginRight={1} />
        <RouterLink primary to={SETTINGS_LOGIN_INTEGRATION_SSO}>
          <FormattedMessage id="admin.components.integration.sso.checklistPage.backLink" />
        </RouterLink>
        <Flex>
          <Spacing marginRight={7}>
            <H2 marginTop={1} marginBottom={1}>
              <FormattedMessage id="admin.components.integration.sso.customSSO.title" />
            </H2>
            <Body marginBottom={4}>
              <FormattedMessage id="admin.components.integration.sso.customSSO.paragraph" />
            </Body>
            <Form>
              <Input
                name="customSSOText"
                label="admin.components.integration.sso.customSSO.input.label1"
                placeholder="admin.components.integration.sso.customSSO.input.default"
                validation={Validation.string().max(50, "admin.components.integration.sso.customSSO.input.label2")}
                value={customText}
                onChange={this.handleInputChange}
              />
              <Button
                id="settingsIntegrationSSONameUpdate_button"
                primary
                marginTop={4}
                marginBottom={2}
                load={loadCustomSSO}
                onClick={this.updateSSOButtonText}
                disabled={!customText || customText.length > 50}>
                <FormattedMessage id="admin.components.integration.sso.customSSO.button.update" />
              </Button>
              <Button
                id="settingsIntegrationSSONameUseDefault_button"
                tertiary
                marginLeft={2}
                load={loadDefaultSSO}
                onClick={this.useDefaulSSOButtonText}>
                <FormattedMessage id="admin.components.integration.sso.customSSO.button.useDefault" />
              </Button>
              {isUpdated && (
                <Flex>
                  <Label weight="bold" large marginLeft={3} color={theme.colors.primary1}>
                    <FormattedMessage id="admin.components.integration.sso.customSSO.button.success" />
                  </Label>
                </Flex>
              )}
            </Form>
          </Spacing>
          <CustomSSOImage />
        </Flex>
      </>
    )
  }
}

export default CustomSSOName
